var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bdd-checklists"},[_c('router-link',{attrs:{"to":"app/bdd/applications"}},[_c('r-button',{attrs:{"simple":"","icon":"chevron-left"}},[_vm._v(" Вернуться назад ")])],1),_c(_vm.componentName,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }